export const appWidgetMap = {
    create: function () {
        var that = this;
        if ($('.js-map-widget').length) {
            that.init();
        }
        window.appWidgetMap = that;

        var appWidgetMapcreatedevent = new CustomEvent('appWidgetMapcreated', {
            // detail: {
            //     slider: sliderID,
            //     value: sliderValue
            // }
        });
        document.dispatchEvent(appWidgetMapcreatedevent);
    },
    init: function (data) {
        data = data || undefined
        var that = this;

        $('.js-map-widget').each(function () {

            var mapID = $(this).attr('id'),
                mapLong = $(this).data('long'),
                mapLat = $(this).data('lat'),
                mainZoom = 15;

            if (data !== undefined) {
                mapLong = parseFloat(data.lng);
                mapLat = parseFloat(data.lat);
            }

            // console.log('map.init', mapID, mapLong, mapLat)

            if (mapLong !== undefined && mapLat !== undefined) {
                if (window['widgetMap' + mapID] !== undefined) {
                    window['widgetMap' + mapID].setView([mapLong, mapLat], mainZoom);
                    L.marker([mapLong, mapLat]).addTo(window['widgetMap' + mapID]);
                } else {
                    var thisMap = new L.map(mapID).setView([mapLong, mapLat], mainZoom);
                    thisMap.scrollWheelZoom.disable();
                    thisMap.on('focus', () => {
                        thisMap.scrollWheelZoom.enable();
                    });
                    thisMap.on('blur', () => {
                        thisMap.scrollWheelZoom.disable();
                    });
                    L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
                        subdomains: ['a', 'b', 'c']
                    }).addTo(thisMap);
                    L.marker([mapLong, mapLat]).addTo(thisMap);
                    window['widgetMap' + mapID] = thisMap;
                }
            }
        });
    }
};
